{
  "version": 1,
  "asset_id": "041c02aa-95d9-4b54-a2ef-936ad78a797e",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/041c02aa-95d9-4b54-a2ef-936ad78a797e/hero-king-salmon-poster.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/041c02aa-95d9-4b54-a2ef-936ad78a797e/hero-king-salmon-poster.jpg",
  "original_filename": "hero-king-salmon-poster.jpg",
  "size": 195192,
  "content_type": "image/jpeg",
  "created_at": "2026-07-03T01:14:20Z"
}
